import apiInstance from "../api";
import endPoints from "../endpoints";

export const addEmailLayout = (payload) => {
  return apiInstance().post(
    `${endPoints.communication.addEmailLayout}`,
    payload
  );
};

export const deleteEmailLayout = (id) => {
  return apiInstance().get(
    `${endPoints.communication.deleteEmailLayout}/${id}`
  );
};

export const deleteCommunication = (id) => {
  return apiInstance().get(
    `${endPoints.communication.deleteCommunication}/${id}`
  );
};

export const postCommunicationCardView = (payload, signal) => {
  return apiInstance().post(
    `${endPoints.communication.postCommunicationCardView}`,
    payload,
    {
      cancelToken: signal,
    }
  );
};

export const getEmailLayout = (payload) => {
  return apiInstance().post(
    `${endPoints.communication.getEmailLayout}`,
    payload
  );
};
export const postSaveCommunication = (payload) => {
  return apiInstance().post(
    `${endPoints.communication.postSaveCommunication}`,
    payload
  );
};

export const getSponsorsByPlanOrPlanGroupIds = (payload) => {
  return apiInstance().post(
    `${endPoints.communication.getSponsorsByPlanOrPlanGroupIds}`,
    payload
  );
};

export const getAdminsByPlanOrPlanGroupIds = (payload) => {
  return apiInstance().post(
    `${endPoints.communication.getAdminsByPlanOrPlanGroupIds}`,
    payload
  );
};

export const getEventsList = () => {
  return apiInstance().get(`${endPoints.communication.getEventsList}`);
};

export const getCommunicationsBasedOnSelectedPlan = (payload) => {
  return apiInstance().post(
    `${endPoints.communication.getCommunicationsBasedOnSelectedPlan}`,
    payload
  );
};

export const getEmailDataById = (id) => {
  return apiInstance().get(`${endPoints.communication.getEmailDataById}/${id}`);
};

export const getCommunicationDetailsById = (id) => {
  return apiInstance().get(
    `${endPoints.communication.getCommunicationDetailsById}/${id}`
  );
};
export const getSentCommunicationDetails = (payload) => {
  return apiInstance().post(
    `${endPoints.communication.getSentCommunicationDetails}`,
    payload
  );
};
export const getSentCommunicationDetailsById = (id) => {
  return apiInstance().get(
    `${endPoints.communication.getSentCommunicationDetailsById}/${id}`
  );
};

export const getConfiguredCommunicationsBasedOnEvent = (payload) => {
  return apiInstance().get(
    `${endPoints.communication.getConfiguredCommunicationsBasedOnEvent}/${payload.eventId}/${payload.planId}`
  );
};

export const savePlanCommunication = (payload) => {
  return apiInstance().post(
    `${endPoints.communication.savePlanCommunication}`,
    payload
  );
};
